"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const Request_1 = require("./constants/Request");
/**
 * @deprecated
 */
const get = params => __awaiter(void 0, void 0, void 0, function* () {
  return yield Request_1.default.get('/v4/ambassador/', params);
});
/**
 * @deprecated
 */
const getById = objectId => __awaiter(void 0, void 0, void 0, function* () {
  return yield Request_1.default.get('/v4/ambassador/' + objectId);
});
exports.default = {
  get,
  getById
};